import Cookies from 'js-cookie';
import history from '__common/modules/history';
import { ActionTypes, ProjectConfigurationActionTypes } from 'actionsConstants';
import { dispatch } from '__common/store';
import { getToken, hitApi, ObservableAjax } from '__common/utils/api';
import { Observable } from 'rxjs/Observable';
import pickBy from 'lodash/pickBy';
import {
  EMPTY_APP_ACTION,
  USER_LOGIN_SUCCESS,
  loginError,
  UPDATE_USER_PREFERENCES,
  REDIRECT_AURORA_PAGE,
  REDIRECT_OS_PAGE,
} from 'actions';
import { ActionsObservable } from 'redux-observable';
import { AnyAction, Store } from 'redux';

interface AuthResponse {
  email: string;
  is_staff: boolean;
  token: string;
  username: string;
  preferences: userPreferences;
  products: number[];
  permissions: string[];
  is_privileged_user?: boolean;
}

export function userLogin(action$) {
  return action$.ofType(ActionTypes.USER_LOGIN_REQUEST)
    .switchMap(({ payload: { username, password, token } }) => {
      const requestBody = {
        withCredentials: true,
        username,
        password,
        token,
      };
      return Observable.ajax(getToken('api/auth/', pickBy(requestBody)))
        .map(({ response }: { response: AuthResponse }) => {
          if (!token) {
            history.push('/');
          }
          Cookies.set('token', response.token, { expires: 365 });
          const notAfterSave = true;

          dispatch(UPDATE_USER_PREFERENCES(response.preferences, notAfterSave));
          const userDataCookie = Cookies.get('USER_DATA');
          let applicationList = {};
          if (userDataCookie) {
            try {
              const userData = JSON.parse(decodeURIComponent(userDataCookie));
              applicationList = userData.application_list || {};
            } catch (e) {
              console.error('Error parsing USER_DATA cookie', e);
            }
          }
          return USER_LOGIN_SUCCESS(response.token, response.username, response.email, response.is_staff || false, response.is_privileged_user || false, response.products || [], response.permissions || [], applicationList);
        })
        .catch(error =>
          Observable.of(loginError(error)),
        );
    });
}

export function userLogout(action$) {
  return action$.ofType(ActionTypes.USER_LOGOUT_REQUEST)
    .map(() => {
      Cookies.remove('token');
      Cookies.remove('_globalToken');
      return { type: ActionTypes.USER_LOGOUT_SUCCESS };
    });
}

export function registrationRequest(action$) {
  return action$.ofType(ActionTypes.REGISTRATION_REQUEST)
    .switchMap((action) => {
      const {
        email,
        password,
        repeatedPassword,
        postRegistrationAction,
        onErrorAction,
      } = action.payload;

      const userDetails = {
        email,
        username: email,
        password,
        password_repeat: repeatedPassword,
      };
      return ObservableAjax({
        takeUntil: action$.ofType(ActionTypes.REGISTRATION_REQUEST),
        nonReduxExtraAction: postRegistrationAction,
        onSuccess: EMPTY_APP_ACTION,
        onErrorAction,
        link: hitApi('post', `api/auth/register/`, userDetails),
      });
    });
}


export function auroraDesignAuthenticationRequest(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(ProjectConfigurationActionTypes.LOAD_AURORA_PROJECT_CONFIGURATION)
    .switchMap(() => {
      const { projectConfiguration: { projectEnvConfig : { token } } } = store.getState();
      const requestBody = {
        withCredentials: true,
        token,
      };
      return Observable.ajax(getToken('api/auth/', pickBy(requestBody)))
        .map(({ response }: { response: AuthResponse }) => {
          if (!token) {
            history.push('/');
          }
          Cookies.set('token', response.token, { expires: 365 });
          const notAfterSave = true;

          dispatch(UPDATE_USER_PREFERENCES(response.preferences, notAfterSave));
          const userDataCookie = Cookies.get('USER_DATA');
          let applicationList = {};
          if (userDataCookie) {
            try {
              const userData = JSON.parse(decodeURIComponent(userDataCookie));
              applicationList = userData.application_list || {};
            } catch (e) {
              console.error('Error parsing USER_DATA cookie', e);
            }
          }
          dispatch(USER_LOGIN_SUCCESS(response.token, response.username, response.email, response.is_staff || false, response?.is_privileged_user || false, response?.products || [], response.permissions || [], applicationList))
          return dispatch(REDIRECT_AURORA_PAGE);
        })
        .catch(error =>
          Observable.of(loginError(error)),
        );
    });
}


export function osDesignAuthenticationRequest(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(ProjectConfigurationActionTypes.LOAD_OS_PROJECT_CONFIGURATION)
    .switchMap(() => {
      const { projectConfiguration: { projectEnvConfig : { token } } } = store.getState();
      const requestBody = {
        withCredentials: true,
        token,
      };
      return Observable.ajax(getToken('api/auth/', pickBy(requestBody)))
        .map(({ response }: { response: AuthResponse }) => {
          if (!token) {
            history.push('/');
          }
          Cookies.set('token', response.token, { expires: 365 });
          const notAfterSave = true;

          dispatch(UPDATE_USER_PREFERENCES(response.preferences, notAfterSave));
          const userDataCookie = Cookies.get('USER_DATA');
          let applicationList = {};
          if (userDataCookie) {
            try {
              const userData = JSON.parse(decodeURIComponent(userDataCookie));
              applicationList = userData.application_list || {};
            } catch (e) {
              console.error('Error parsing USER_DATA cookie', e);
            }
          }
          dispatch(USER_LOGIN_SUCCESS(response.token, response.username, response.email, response.is_staff || false, response?.is_privileged_user || false, response?.products || [], response.permissions || [], applicationList))
          return dispatch(REDIRECT_OS_PAGE);
        })
        .catch(error =>
          Observable.of(loginError(error)),
        );
    });
}
